import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { SupportComponent } from '../support/support.component';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
    constructor(private modalService: NgbModal) {}

    ngOnInit() {}

    openSupportModal() {
        const modalRef = this.modalService.open(SupportComponent, {
            backdrop: 'static',
        });

        modalRef.componentInstance.name = 'PaymentSupport';
    }
}
